'use strict';
(function ($, Drupal) {
    Drupal.behaviors['mdoctorBlog-page'] = {
        attach: function attach(context, settings) {
            const $context = $('.cpl-blog-page-block', context);
            $context.once('blog-page-block').each((index, el) => {
                // Disable equalizer from base theme.
                $(el).foundation('destroy');
            });
        }
    };
    Drupal.behaviors['mdoctorEvents-page'] = {
        attach: function attach(context, settings) {
            function getResolvedDate(rawDate) {
                const date = rawDate.split('-');
                return `${ date[1] }/${ date[2] }/${ date[0] }`;
            }
            function setFormDates(dateFrom, dateTo) {
                $('#edit-event-from').val(dateFrom);
                $('#edit-event-to').val(dateTo);
                $('#edit-submit-events').click();
            }
            function getDayOfMonth(dateFrom = true) {
                const $month = $('.fc-day-top').not('.fc-other-month');
                return dateFrom ? getResolvedDate($month[0].dataset.date).toString() : getResolvedDate($month[$month.length - 1].dataset.date).toString() + ' 23:59';
            }
            const $context = $('.view-event-listing', context);
            $(window).on('load', () => {
                $context.once('event-calendar').each(() => {
                    const $calendar = $context.find('#calendar');
                    const $moveButtons = $calendar.find('.fc-button');
                    const firstDayOfMonth = getDayOfMonth();
                    const lastDayOfMonth = getDayOfMonth(false);
                    setFormDates(firstDayOfMonth, lastDayOfMonth);
                    $moveButtons.click(e => {
                        e.preventDefault();
                        const firstDayOfMonth = getDayOfMonth();
                        const lastDayOfMonth = getDayOfMonth(false);
                        setFormDates(firstDayOfMonth, lastDayOfMonth);
                    });
                });
            });
        }
    };
    Drupal.behaviors['mdoctorFooter'] = {
        attach: function attach(context, settings) {
            const $context = $('.footer-menu-block, .footer-contact-block', context);
            $context.once('footer-collapse-expand-blocks').each((index, el) => {
                const $block = $(el);
                const $title = $block.find('.footer-title');
                $title.click(() => $block.toggleClass('is-open'));
            });
        }
    };
    Drupal.behaviors['mdoctorLocation-dispensary-map'] = {
        attach: function attach(context, settings) {
            const $context = $('.location-buttons, .dispensary-buttons', context);
            $context.once('locations-dispensary-page-buttons').each((index, el) => {
                const $this = $(el);
                const $body = $('body');
                $this.find('.location-button-map, .dispensary-button-map').click(() => $body.addClass('is-map-open is-fixed'));
                $this.find('.location-button-list, .dispensary-button-list').click(() => $body.removeClass('is-map-open is-fixed'));
            });
        }
    };
    Drupal.behaviors['mdoctorLocation-multicheckbox'] = {
        attach: function attach(context, settings) {
            const $context = $('#views-exposed-form-locations-content-locations-map .form-composite', context);
            $context.once('locations-multiselect').each((index, el) => {
                const $this = $(el);
                $this.find('legend').click(() => $this.toggleClass('is-open'));
            });
        }
    };
    Drupal.behaviors['mdoctorNews-articles-embed-video'] = {
        attach: function attach(context, settings) {
            const $responsiveVideo = $('.field-name-body iframe, .field-name-field-par-html iframe', context);
            $responsiveVideo.once('responsive-iframe').each((index, el) => {
                const $this = $(el);
                if (!$this.parent().hasClass('iframe-responsive')) {
                    $this.wrap('<div class="iframe-responsive"></div>');
                }
            });
        }
    };
    Drupal.behaviors['mdoctorPricing-slideshow'] = {
        attach: function attach(context, settings) {
            const $context = $('.pricing-plan-mobile-slideshow', context);
            $context.once('pricing-block-slideshow').each((index, el) => {
                const $this = $(el);
                const slideshowOptions = {
                    dots: true,
                    arrows: false,
                    autoplay: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '40px',
                    mobileFirst: true,
                    responsive: [
                        {
                            breakpoint: 640,
                            settings: { centerPadding: '100px' }
                        },
                        {
                            breakpoint: 700,
                            settings: { centerPadding: '130px' }
                        },
                        {
                            breakpoint: 780,
                            settings: { centerPadding: '180px' }
                        }
                    ]
                };
                const initSlideshow = () => {
                    if ($(window).width() < 960) {
                        if (!$this.hasClass('slick-initialized')) {
                            $this.slick(slideshowOptions);
                        }
                        const sliderHeight = `${ $this.find('.slick-track').height() }px`;
                        $this.find('.pricing-plan').css('height', sliderHeight);
                    } else if ($this.hasClass('slick-initialized')) {
                        $this.slick('unslick');
                        $this.find('.pricing-plan').css('height', '');
                    }
                };
                if ($this.find('.views-row').length > 1) {
                    initSlideshow();
                    let timeout;
                    $(window).on('resize orientationChange', () => {
                        clearTimeout(timeout);
                        timeout = setTimeout(initSlideshow, 200);
                    });
                }
            });
        }
    };
}(jQuery, Drupal));